import "../assets/common7.css";
import { d as t } from "./defined-by-default.11c0fbdd.js";
import { c } from "./index.bddf5ebb.js";
const l = "_chip_1h3b2_1", o = "_label_1h3b2_36", b = "_selected_1h3b2_60", _ = "_active_1h3b2_60", r = "_leadingIcon_1h3b2_67", d = "_trailingIcon_1h3b2_72", h = "_expandable_1h3b2_88", m = "_colorContent_1h3b2_92", g = "_dismissible_1h3b2_104", e = {
  chip: l,
  label: o,
  selected: b,
  active: _,
  leadingIcon: r,
  trailingIcon: d,
  expandable: h,
  colorContent: m,
  dismissible: g
}, v = ({
  className: n,
  isSelected: s,
  isActive: i,
  intent: a
}) => c(e.chip, n, {
  [e.selected]: t(s),
  [e.active]: t(i),
  [e.dismissible]: a === "dismissible"
}), f = (n) => {
  let s, i;
  switch (n) {
    case "expandable":
      s = "24/symbol/chevron-back", i = c(e.trailingIcon, e.expandable);
      break;
    case "dismissible":
      s = "24/symbol/close", i = c(e.trailingIcon);
      break;
  }
  return { trailingIcon: s, trailingIconClass: i };
};
export {
  v as c,
  f as g,
  e as s
};
//# sourceMappingURL=common.cbb2911d.js.map
